import {Injectable} from '@angular/core';

let Debug: any = require('debug');
let debug, debugOff = function (...any) {};
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:LogsService'));

/**
 * Renders the debug statements as console.log with temistamps and colors.
 * Extrmely useful for debugging.
 * To display the logged messages type in console: `debugStart('app')`
 */
@Injectable()
export class LogsService {
    
    constructor () {
        // 'Construct logs service' );

        this._setupConsoleDebugApi();
    }

    private _setupConsoleDebugApi () {
        // 'Setup console debug API' );

        // Enable logs
        (<any>window).debugStart = ( moduleName ) => {

            if (typeof moduleName === 'string') {

                // Enable logs just for specified module
                console.log( 'Enable debug:', moduleName );
                Debug.enable( moduleName + ':*' );
            } else {

                // Enable all logs
                console.log( 'Enable debug all' );
                Debug.enable( '*' );
            }
        };

        // Disable logs
        (<any>window).debugStop = ( moduleName ) => {

            if (typeof moduleName === 'string') {

                // Disable logs just for specified module
                console.log( 'Disable debug:', moduleName );
                Debug.disable( moduleName + ':*' );
            } else {

                // Disable all logs
                console.log( 'Disable debug all' );
                Debug.disable( '*' );
            }
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/services/logs-service.ts